import React from "react";
import {
  Drawer,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
  Stack,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import CircleIcon from "@mui/icons-material/Circle";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const NotificationDrawer = ({
  open,
  onClose,
  notifications,
  onMarkAsRead,
  onMarkAllAsRead,
}) => {
  const notificationList = notifications?.notifications?.data || [];

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: 380, maxWidth: "100%" },
      }}
    >
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Notifications
        </Typography>
        <Box>
          {notificationList.length > 0 && (
            <Typography
              variant="caption"
              color="primary"
              sx={{ cursor: "pointer", mr: 2, fontWeight: "bold" }}
              onClick={onMarkAllAsRead}
            >
              Mark all as read
            </Typography>
          )}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <Divider />

      {notificationList.length === 0 ? (
        <Box
          sx={{
            p: 4,
            textAlign: "center",
            color: "text.secondary",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <NotificationsNoneIcon sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
          <Typography>No notifications yet</Typography>
        </Box>
      ) : (
        <List sx={{ p: 0 }}>
          {notificationList.map((notification) => (
            <React.Fragment key={notification.id}>
              <ListItem
                alignItems="flex-start"
                button
                onClick={() =>
                  !notification.read_at && onMarkAsRead(notification.id)
                }
                sx={{
                  bgcolor: notification.read_at
                    ? "transparent"
                    : "action.hover",
                  transition: "0.2s",
                  "&:hover": { bgcolor: "action.selected" },
                  cursor: "pointer",
                }}
              >
                <ListItemText
                  primary={
                    <Box
                      component="span"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        fontWeight="bold"
                        sx={{ mr: 1 }}
                      >
                        {notification.data.title}
                      </Typography>
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          {dayjs(notification.created_at).fromNow()}
                        </Typography>
                        {!notification.read_at && (
                          <CircleIcon color="primary" sx={{ fontSize: 10 }} />
                        )}
                      </Stack>
                    </Box>
                  }
                  secondary={
                    <Typography
                      component="span"
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {notification.data.message}
                    </Typography>
                  }
                />
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          ))}
        </List>
      )}
    </Drawer>
  );
};

export default NotificationDrawer;
